import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const EmployeePayrollComponent = () => {
  return (
    <div className="employees">
      <Container fluid>
        <Outlet />
      </Container>
    </div>
  );
};
export default EmployeePayrollComponent;
